import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface Props {
  data: {
    name: string;
    value: string;
    icon: React.ReactNode;
  }[];
  /** Number of columns at md+ breakpoint. Default 3. */
  columns?: 3 | 4;
}

export function SectionCards({ data, columns = 3 }: Props) {
  const gridColsClass =
    columns === 4
      ? "md:grid-cols-2 lg:grid-cols-4"
      : "@xl/main:grid-cols-3";

  return (
    <div className={`grid grid-cols-1 gap-4 ${gridColsClass} *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card`}>
      {data.map((item, index) => (
        <Card key={index} className="@container/card">
          <CardHeader className="relative flex items-center gap-2 justify-between">
            <div>
              <CardDescription className="uppercase">{item.name}</CardDescription>
              <CardTitle className="@[250px]/card:text-2xl text-xl font-medium tabular-nums">{item.value}</CardTitle>
            </div>
            <span className="text-primary">{item.icon}</span>
          </CardHeader>
        </Card>
      ))}
    </div>
  );
}
